export default __webpack_public_path__ + "static/media/image-scorecard-header.d73d06bc.png";